import { useParams, Link, NavLink } from "react-router-dom";
import React, { useState, useEffect, useContext } from "react";
import "./Details.css";
import { AuthContext } from "./Context";
import { db } from './Firebase';
import { collection, deleteDoc, doc, onSnapshot, orderBy, query } from 'firebase/firestore';
function Details() {
useEffect(()=>{
const sparepartsCollectionRef = collection(db, "moraraFurnitures");
const sparepartsQuery = query(sparepartsCollectionRef, orderBy("createdAt", "desc"));
  const unsubParts = onSnapshot(sparepartsQuery, (partsSnapshot) => {
    setCarData(partsSnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })));
  });

  return ()=>{
    unsubParts()
  }

  },[])
  const [mainImage, setMainImage] = useState(0);
  const [carData, setCarData] = useState([]);
 const params = useParams();
const currentId =params.id;

const clickedCarCard = carData.find((item) => item.id === currentId);


  
   

 

  useEffect(()=>{
      if (clickedCarCard?.name) {
        document.title = `${clickedCarCard.name} | Morara Furniture`;
      } else {
        document.title = "Morara Furniture - Furniture Details";
      }
  },[clickedCarCard])

  



  if (!clickedCarCard) {
    return <p style={{ textAlign: "center", marginTop: "100px",color:"black" }}>Loading...</p>;
  }


  
  
  const dynamicSytle = () => {
    return clickedCarCard.subimages[mainImage] || clickedCarCard.subimages[0];
  };

  const Message = `Hello, I saw your site and I'm interested in the ${clickedCarCard.name},sieze:${clickedCarCard.size}.`;
  const encodedMessage = encodeURIComponent(Message);

  const handleNext = () => {
    setMainImage((prevCount) => (prevCount + 1) % 6);
  };

  const handlePrevious = () => {
    setMainImage((prevCount) => (prevCount - 1 + 6) % 6);
  };

  

  return (
    <>
    <div className="product-container">
      <div className="breadcrumb" id="breadcrumb">
          <NavLink to="/">Home</NavLink> <span className="right-arrow">{">"}</span>{" "}
          <NavLink to="/products">Products</NavLink> <span className="right-arrow">{">"}</span>{" "}
          <span className="breadcumb-heading">{clickedCarCard.name}</span>
      </div>

      <div className="details-container">
        <div className="left">
          <div className="mainimage">
            <i className="fa-solid fa-arrow-left" id="fa-solid" onClick={handlePrevious}></i>
            <img src={dynamicSytle()} className="main" alt={clickedCarCard.name} key={mainImage} />
            <i className="fa-solid fa-arrow-right" onClick={handleNext}></i>
          </div>
          <div className="thumbnail-bar">
            {clickedCarCard.subimages.slice(0, 6).map((img, index) => (
              <img
                key={index}
                alt={`thumb${index}`}
                className={mainImage === index ? "active" : ""}
                src={img}
                onClick={() => setMainImage(index)}
              />
            ))}
          </div>
        </div>

        <div className="right">
          <h1>{clickedCarCard.name}</h1>
          <p className="description">{clickedCarCard.description}</p>

         

          <div className="buttons">
            <a href={`https://wa.me/254799589076?text=${encodedMessage}`} target="_blank" className="whatsapp"><i className="fa-brands fa-whatsapp"></i>Enquire <span className="whatsapp-dissapear"> via WhatsApp</span></a>
            <a href="tel:0799589076" className="call" id="call"><i className="fa-solid fa-phone-volume"></i>Call now</a>
          </div>

          <div className="price">
            {new Intl.NumberFormat("en-KE", {
              style: "currency",
              currency: "KES",
              minimumFractionDigits: 0,
            }).format(clickedCarCard.price)}
          </div>
        </div>
      </div>
      </div>
    </>
  );
}

export default Details;
